import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const PagesPage = lazy(() =>
  import("@/admin/pages/PagesPage").then((m) => ({ default: m.PagesPage })),
);

export const Route = createFileRoute("/admin/pages")({
  component: () => (
    <Suspense fallback={null}>
      <PagesPage />
    </Suspense>
  ),
});
